import { TFunction } from "i18next";
import { FaqItemDto } from "../components/blocks/marketing/faq/FaqBlockUtils";

export function defaultFaq({ t }: { t: TFunction }): FaqItemDto[] {
  const items: FaqItemDto[] =
    [
      {
        "question": "What is Lunova?",
        "answer": "Lunova is a platform that allows you to create custom alerts for QuickBooks Online, automating financial monitoring by notifying you of key events such as deposits, bills, and invoices."
      },
      {
        "question": "Does Lunova work with QuickBooks Desktop?",
        "answer": "Lunova fully integrates with QuickBooks Online only."
      },
      {
        "question": "Do I need to change how I manage QuickBooks?",
        "answer": "No — Lunova works in the background to monitor your existing books and notify you when something needs your attention."
      },
      {
        "question": "How do I set up custom alerts?",
        "answer": "After signing up, access the rule builder in your Lunova dashboard. Select an attribute (e.g., Total Amount, Payment Method) and configure the corresponding condition and value to trigger an alert."
      },
      {
        "question": "Will Lunova modify my QuickBooks data?",
        "answer": "No, Lunova does not modify, update, delete, or otherwise alter any of your QuickBooks data. We only monitor your data and trigger alerts based on the data we receive from QuickBooks."
      },
      {
        "question": "Which QuickBooks entities does Lunova support?",
        "answer": "Currently, Lunova supports key QuickBooks entities including deposits, bills, and invoices, with plans to expand to additional entities as we grow."
      },
      {
        "question": "How does Lunova integrate with QuickBooks?",
        "answer": "Lunova integrates with QuickBooks Online using webhooks and API calls, enabling real-time data synchronization so that alerts are triggered based on the most current financial information."
      },
      {
        "question": "What types of alerts can I create?",
        "answer": "You can create various alerts such as high-value deposit notifications, vendor bill increases, overdue invoices, and more. Each alert is fully customizable based on your specific business rules."
      },
      {
        "question": "What pricing plans are available?",
        "answer": "We offer two tiers: Basic at $29/month (or $300/year), Pro at $79/month (or $850/year) each designed to meet different usage needs."
      },
      {
        "question": "Is there a free trial available?",
        "answer": "Yes, we offer a 7-day free trial for all new users (Credit Card Required). You can cancel anytime before the trial ends."
      },
      {
        "question": "Is there a money-back guarantee?",
        "answer": "Yes, we offer a 14-day money-back guarantee for all new users",
      },
      {
        "question": "What support options do you offer?",
        "answer": "Basic users receive email support during business hours. Pro and Enterprise plans come with priority support via email and chat, with Enterprise customers enjoying dedicated account management."
      },
      {
        "question": "How do I connect my QuickBooks account?",
        "answer": "Simply navigate to the settings in your Lunova dashboard and follow the steps to integrate your QuickBooks Online account. Detailed instructions are provided in our documentation."
      },
      {
        "question": "How does Lunova comply with GDPR?",
        "answer": "Lunova is committed to GDPR compliance by ensuring data protection and privacy for all users. We implement robust security measures, provide data access controls, allow users to manage their personal information, and support data deletion requests. Additionally, we only process and store data necessary for our services and ensure third-party integrations meet GDPR standards."
      }
    ];
  return items;
}
